"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dompurify_1 = __importDefault(require("dompurify"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var AppTemplateEditor_module_css_1 = __importDefault(require("./AppTemplateEditor.module.css"));
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var react_codemirror_1 = __importDefault(require("@uiw/react-codemirror"));
var lang_liquid_1 = require("@codemirror/lang-liquid");
var lang_json_1 = require("@codemirror/lang-json");
var liquidjs_1 = require("liquidjs");
var view_1 = require("@codemirror/view");
var codemirror_theme_vscode_1 = require("@uiw/codemirror-theme-vscode");
var autocomplete_1 = require("@codemirror/autocomplete");
var codemirror_indentation_markers_1 = require("@replit/codemirror-indentation-markers");
var material_1 = require("@mui/material");
var standalone_1 = __importDefault(require("prettier/standalone"));
var parser_html_1 = __importDefault(require("prettier/parser-html"));
var parser_babel_1 = __importDefault(require("prettier/parser-babel"));
var parser_postcss_1 = __importDefault(require("prettier/parser-postcss"));
var getCustomFontTheme = function (fontSize) {
    return view_1.EditorView.theme({
        "&": {
            fontFamily: "Geomanist, sans-serif",
            fontSize: "".concat(fontSize, "px")
        },
        ".cm-content": {
            fontFamily: "Geomanist, sans-serif",
            fontSize: "".concat(fontSize, "px")
        }
    });
};
var indentationConfig = {
    highlightActiveBlock: true,
    hideFirstIndent: false,
    markerType: "fullScope",
    thickness: 1,
    activeThickness: 1.6,
    colors: {
        light: "#D0D0D0",
        dark: "#3B3B3B",
        activeLight: "#A0A0A0",
        activeDark: "#777777"
    }
};
var createLiquidErrorSnippet = function (templateContent, error, contextData) {
    var _a, _b;
    var output = "Error rendering template: ".concat(error.message || "Unknown error", "\n");
    var lineNum = (_a = error.token) === null || _a === void 0 ? void 0 : _a.line;
    var colNum = (_b = error.token) === null || _b === void 0 ? void 0 : _b.col;
    if (lineNum != null && colNum != null) {
        output += "line:".concat(lineNum, ", col:").concat(colNum, "\n\n");
    }
    var lines = templateContent.split("\n");
    var snippetRange = 2;
    var start = Math.max(0, (lineNum || 1) - snippetRange - 1);
    var end = Math.min(lines.length, (lineNum || 1) + snippetRange);
    for (var i = start; i < end; i++) {
        var lineIndex = i + 1;
        output += "".concat(lineIndex, " | ").concat(lines[i], "\n");
        if (lineIndex === lineNum && colNum != null) {
            output += " ".repeat("".concat(lineIndex, " | ").length + colNum) + "^\n";
        }
    }
    if (error.stack) {
        output += "\nStack Trace:\n".concat(error.stack);
    }
    output += "\nContext Data:\n".concat(contextData);
    return output;
};
var engine = new liquidjs_1.Liquid();
var themeSetting = new q_play_core_1.SelectSetting("theme", "Theme");
themeSetting.options = [
    { label: "Light", value: "light" },
    { label: "Dark", value: "dark" }
];
var fontSizeSetting = new q_play_core_1.NumberRangeSetting("fontSize", "Font Size");
fontSizeSetting.minValue = 10;
fontSizeSetting.maxValue = 24;
fontSizeSetting.defaultValue = 14;
fontSizeSetting.showInputField = true;
var logger = q_play_core_1.logManager.getLogger();
function formatLiquidCode(template) {
    try {
        var styleTagRegex = /(<style[^>]*>)([\s\S]*?)(<\/style>)/gi;
        var formattedTemplate = template;
        formattedTemplate = template.replace(styleTagRegex, function (match, openTag, cssContent, closeTag) {
            try {
                var formattedCss = standalone_1.default.format(cssContent, {
                    parser: "css",
                    plugins: [parser_postcss_1.default],
                    printWidth: 80,
                    tabWidth: 2
                });
                return "".concat(openTag).concat(formattedCss).concat(closeTag);
            }
            catch (cssError) {
                logger.error("Error formatting CSS:", cssError);
                return match;
            }
        });
        return standalone_1.default.format(formattedTemplate, {
            parser: "html",
            plugins: [parser_html_1.default],
            printWidth: 80,
            tabWidth: 2,
            useTabs: false,
            semi: true,
            singleQuote: false,
            trailingComma: "none",
            bracketSpacing: true,
            htmlWhitespaceSensitivity: "css"
        });
    }
    catch (error) {
        logger.error("Error formatting Liquid template:", error);
        return template;
    }
}
function formatJsonCode(context) {
    try {
        return standalone_1.default.format(context, {
            parser: "json",
            plugins: [parser_babel_1.default],
            printWidth: 80,
            tabWidth: 2
        });
    }
    catch (error) {
        logger.error("Error formatting JSON:", error);
        return context;
    }
}
var AppTemplateTab = (0, react_1.forwardRef)(function (_a, ref) {
    var appTemplateData = _a.appTemplateData, templateContent = _a.templateContent, onTemplateChange = _a.onTemplateChange, contextData = _a.contextData, onContextChange = _a.onContextChange, renderedOutput = _a.renderedOutput, onTemplateSaved = _a.onTemplateSaved;
    var dataProvider = (0, AjaxProvider_1.default)("/api");
    var _b = (0, react_1.useState)(false), snackbarOpen = _b[0], setSnackbarOpen = _b[1];
    var _c = (0, react_1.useState)(""), snackbarMessage = _c[0], setSnackbarMessage = _c[1];
    var _d = (0, react_1.useState)("success"), snackbarSeverity = _d[0], setSnackbarSeverity = _d[1];
    var _e = (0, react_1.useState)(null), editorError = _e[0], setEditorError = _e[1];
    var _f = (0, react_1.useState)("light"), selectedTheme = _f[0], setSelectedTheme = _f[1];
    var _g = (0, react_1.useState)(14), fontSize = _g[0], setFontSize = _g[1];
    var _h = (0, react_1.useState)(null), settingsAnchor = _h[0], setSettingsAnchor = _h[1];
    (0, react_1.useEffect)(function () {
        var savedTheme = localStorage.getItem("editorTheme");
        var savedFontSize = localStorage.getItem("editorFontSize");
        if (savedTheme)
            setSelectedTheme(savedTheme);
        if (savedFontSize)
            setFontSize(Number(savedFontSize));
    }, []);
    var saveSettingsToLocalStorage = function (theme, size) {
        localStorage.setItem("editorTheme", theme || "light");
        localStorage.setItem("editorFontSize", String(size || 14));
    };
    var codeMirrorTheme = (0, react_1.useMemo)(function () { return (selectedTheme === "light" ? codemirror_theme_vscode_1.vscodeLight : codemirror_theme_vscode_1.vscodeDark); }, [selectedTheme]);
    var customFontTheme = getCustomFontTheme(fontSize);
    var templateKeyBinding = (0, react_1.useMemo)(function () { return view_1.keymap.of([
        {
            key: "Shift-F1",
            run: function (view) {
                var code = view.state.doc.toString();
                var formatted = formatLiquidCode(code);
                var changes = { from: 0, to: view.state.doc.length, insert: formatted };
                var tr = view.state.update({
                    changes: changes,
                    selection: view.state.selection.map(view.state.changes(changes))
                });
                view.dispatch(tr);
                return true;
            }
        }
    ]); }, []);
    var contextKeyBinding = (0, react_1.useMemo)(function () { return view_1.keymap.of([
        {
            key: "Shift-F1",
            run: function (view) {
                var code = view.state.doc.toString();
                var formatted = formatJsonCode(code);
                var changes = { from: 0, to: view.state.doc.length, insert: formatted };
                var tr = view.state.update({
                    changes: changes,
                    selection: view.state.selection.map(view.state.changes(changes))
                });
                view.dispatch(tr);
                return true;
            }
        }
    ]); }, []);
    var templateExtensions = [
        templateKeyBinding,
        (0, lang_liquid_1.liquid)({}),
        customFontTheme,
        (0, codemirror_indentation_markers_1.indentationMarkers)(indentationConfig),
        (0, autocomplete_1.autocompletion)()
    ];
    var contextExtensions = [
        contextKeyBinding,
        (0, lang_json_1.json)(),
        customFontTheme,
        (0, codemirror_indentation_markers_1.indentationMarkers)(indentationConfig),
        (0, autocomplete_1.autocompletion)()
    ];
    var previewExtensions = [
        (0, lang_liquid_1.liquid)({}),
        customFontTheme,
        (0, codemirror_indentation_markers_1.indentationMarkers)(indentationConfig),
        (0, autocomplete_1.autocompletion)()
    ];
    var handleSaveTemplate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var version, endpoint, payload, error_1, msg, errorMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    version = appTemplateData.current_version || "1.0";
                    endpoint = "app-template-editor/".concat(appTemplateData.id, "/").concat(version, "/update");
                    payload = { template: templateContent };
                    return [4 /*yield*/, dataProvider.update(endpoint, {
                            id: "",
                            data: payload,
                            previousData: {}
                        })];
                case 1:
                    _a.sent();
                    onTemplateSaved === null || onTemplateSaved === void 0 ? void 0 : onTemplateSaved(templateContent);
                    setSnackbarMessage("Template saved successfully.");
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    logger.info("Template saved successfully.");
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    msg = error_1.message || "Unknown error";
                    errorMsg = "Error saving template: ".concat(msg);
                    logger.error(errorMsg);
                    setSnackbarMessage(errorMsg);
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var validateTemplate = function (template, context) { return __awaiter(void 0, void 0, void 0, function () {
        var parsedTemplate, parsedContext, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    try {
                        JSON.parse(context);
                    }
                    catch (error) {
                        return [2 /*return*/, {
                                error: "Context Error: ".concat(error.message, "\n\nContext Data:\n").concat(context),
                                output: null
                            }];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    parsedTemplate = engine.parse(template);
                    parsedContext = JSON.parse(context);
                    return [4 /*yield*/, engine.render(parsedTemplate, parsedContext)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, { error: null, output: null }];
                case 3:
                    error_2 = _a.sent();
                    return [2 /*return*/, {
                            error: createLiquidErrorSnippet(template, error_2, context),
                            output: null
                        }];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleTemplateChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onTemplateChange(value);
                    return [4 /*yield*/, validateTemplate(value, contextData)];
                case 1:
                    result = _a.sent();
                    if (result.error) {
                        setEditorError(result.error);
                    }
                    else {
                        setEditorError(null);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleContextChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onContextChange(value);
                    if (!value.trim()) {
                        setEditorError(null);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, validateTemplate(templateContent, value)];
                case 1:
                    result = _a.sent();
                    if (result.error) {
                        setEditorError(result.error);
                    }
                    else {
                        setEditorError(null);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        handleSaveTemplate: handleSaveTemplate,
        openSettings: function (anchorEl) {
            setSettingsAnchor(anchorEl);
        }
    }); });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Popover, { anchorEl: settingsAnchor, open: Boolean(settingsAnchor), onClose: function () { return setSettingsAnchor(null); }, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, sx: {
                borderRadius: "10px",
                marginLeft: "45px",
                ".MuiPaper-root": { borderRadius: "10px" }
            } },
            react_1.default.createElement("div", { style: { padding: "1rem", width: "250px" } },
                react_1.default.createElement(q_play_components_1.SettingsComponent, { key: "themeSetting", value: selectedTheme, disabled: false, setting: themeSetting, onChange: function (event) {
                        var newTheme = event.target.value;
                        setSelectedTheme(newTheme);
                        saveSettingsToLocalStorage(newTheme, fontSize);
                    } }),
                react_1.default.createElement(q_play_components_1.SettingsComponent, { key: "fontSizeSetting", value: fontSize, disabled: false, setting: fontSizeSetting, onChange: function (event) {
                        var newSize = parseInt(event.target.value, 10) || 14;
                        setFontSize(newSize);
                        saveSettingsToLocalStorage(selectedTheme, newSize);
                    } }),
                react_1.default.createElement("div", { style: { marginTop: "10px", color: "var(--info-color)" } },
                    react_1.default.createElement("strong", null, "Commands"),
                    react_1.default.createElement("div", null, "Format - Shift + F1")))),
        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default.container },
            react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["left-column"] },
                react_1.default.createElement("div", { style: { marginBottom: "15px" } },
                    react_1.default.createElement(react_codemirror_1.default, { key: "template-editor", autoFocus: true, value: templateContent, placeholder: "Template", style: { borderRadius: "15px" }, height: "40vh", width: "95vh", theme: codeMirrorTheme, extensions: templateExtensions, onChange: function (value) { return handleTemplateChange(value); } })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(react_codemirror_1.default, { key: "context-editor", value: contextData, placeholder: "Context", height: "30vh", width: "95vh", style: { borderRadius: "15px" }, theme: codeMirrorTheme, extensions: contextExtensions, onChange: function (value) { return handleContextChange(value); } }))),
            react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["right-column"] },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(react_codemirror_1.default, { value: editorError || dompurify_1.default.sanitize(renderedOutput), placeholder: "Preview", height: "72vh", style: { borderRadius: "15px", maxWidth: "98vh" }, theme: codeMirrorTheme, extensions: previewExtensions, editable: false })))),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); }, message: snackbarMessage, severity: snackbarSeverity, snackbarStyle: { marginTop: "95px" } })));
});
AppTemplateTab.displayName = "AppTemplateTab";
exports.default = AppTemplateTab;
